/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  AbstractFormComponent,
  BuilderNavigationService,
  CommonActions,
  FormActionPipelines,
  FormFlowState,
} from '@gh/builder-shared';
import { ActionFlow, getRouteInitData } from '@gh/common-shared';
import { assign } from 'lodash';
import { RfqGeneral } from '../../../resources/lead.model';
import { RfqBusinessService } from '../../../resources/rfq-business.service';
import { RfqGeneralTabFormState } from './rfq-general-tab-form.service';

@Component({
  standalone: false,
  selector: 'gh-lead-details-rfq-general-tab',
  templateUrl: 'rfq-general-tab.component.html',
  styleUrls: ['rfq-general-tab.component.scss'],
  viewProviders: [
    RfqGeneralTabFormState,
  ],
})
export class RfqGeneralTabComponent extends AbstractFormComponent<RfqGeneral> implements OnInit {

  constructor(private route: ActivatedRoute,
              private navigationService: BuilderNavigationService,
              public form: RfqGeneralTabFormState,
              private pipelines: FormActionPipelines,
              private actions: CommonActions,
              private businessService: RfqBusinessService) {
    super();
  }

  ngOnInit(): void {
    const { original } = getRouteInitData(this.route);

    assign(this, { original });
    this.form.build(original);
  }

  get completeFlow(): ActionFlow<FormFlowState<RfqGeneral>> {
    return this.pipelines.complete({
      execute: this.actions.execute((state: FormFlowState<RfqGeneral>) =>
        this.businessService.updateRfqGeneral(state.form.submitValue)),
      finish: (state: FormFlowState<RfqGeneral>) => {
        const { value } = state;
        this.form.build(value);
      },
    });
  }

  onUpdateForm(): void {
    this.form.updateForm();
  }

  goToAel(): void {
    this.navigationService.goToAel({
      label: 'lbl_rfq_management',
      entityType: 'SALES_FOLDER',
      entityId: this.form.group.get('salesFolderId')!.value,
    });
  }
}
